import { render } from "./AboutScreen.vue?vue&type=template&id=6ef4951f&scoped=true"
import script from "./AboutScreen.vue?vue&type=script&lang=js"
export * from "./AboutScreen.vue?vue&type=script&lang=js"

import "./AboutScreen.vue?vue&type=style&index=0&id=6ef4951f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef4951f"]])

export default __exports__